<bp-input
	name="cc-number"
	[label]="label"
	[color]="color"
	[appearance]="appearance"
	[floatLabel]="floatLabel"
	[hideClearButton]="hideClearButton"
	[required]="!!required"
	[hint]="hint"
	[pending]="pending"
	[nativeAutocomplete]="nativeAutocomplete"
	[mask]="mask"
	[formControl]="_internalControl"
	[isSecret]="true"
>
	<bp-payment-card-brand *ngIf="paymentCardBrand" @fade noTooltip [src]="paymentCardBrand"></bp-payment-card-brand>
</bp-input>
